export default "__VITE_ASSET__Dt8Hefow__"